const activeLicenseConstants = {
  NO_SEARCH:0,
  OK_LOCATE:1,
  KO_LOCATE:2,
  OK_ACTIVATION:3,
  KO_ACTIVATION:4
}
export default activeLicenseConstants